import Categories from '@/domain/Categories'
import { getQueryParams } from '@/infrastructure/Utils'

setupBookAndJoin()

const appGlobalProps = global.appGlobalProps || {}
export const overrideDomain = localStorage.getItem('override-domain') || ''
export const location =
  document.documentElement && document.documentElement.lang
    ? document.documentElement.lang.toLocaleLowerCase()
    : 'en-us'
export const language = location.split('-')[0]
export const region = location.split('-')[1]
export const availabilityApi = overrideDomain
  ? `${overrideDomain}/availability-api`
  : process.env.VUE_APP_AVAILABILITY_API
export const contentApi = overrideDomain
  ? `${overrideDomain}/content-api`
  : process.env.VUE_APP_CONTENT_API
export const apiInitiate = overrideDomain
  ? `${overrideDomain}/booking-process-api/pre-booking`
  : process.env.VUE_APP_API_INITIATE
export const bookingIgnore = overrideDomain
  ? `${overrideDomain}/booking-process-api`
  : process.env.VUE_APP_API_IGNORE
export const checkoutPageUrl = '/' + location + process.env.VUE_APP_CHECKOUT_PAGE
export const upsellingPageUrl = '/' + location + process.env.VUE_APP_UPSELLING_PAGE
export const assetsUrl = appGlobalProps.assetsUrl || process.env.VUE_APP_ASSETS_URL
export const apiKey = process.env.VUE_APP_GOOGLE_API_KEY
export const apiKeyAzure = process.env.VUE_APP_AZURE_API_KEY
export const apiSignature = process.env.VUE_APP_GOOGLE_API_SIGNATURE
export const defaultNonLoggedTab = appGlobalProps.defaultRateTab || Categories.STANDARD
export const isRezidorHotel = appGlobalProps.isRezidorHotel === 'Yes'
export const tridionLabels = window.tridionLabels || {}
export const googleMapsApiKey = window.googleMapsApiKey || 'gme-radissonhospitality'
export const { origin } = global.location
export const loyaltyConsentCookieValue = !!global.Cookie.read(
  global.cookieDictionary.loyaltyConsentRates
)
export function setupBookAndJoin() {
  const { bookAndJoin } = getQueryParams(window.location._search || window.location.search)
  if (bookAndJoin && bookAndJoin !== 'false') {
    global.Cookie.set(global.cookieDictionary.loyaltyConsentRates, true)
  }
}
export const isChina = appGlobalProps.isChina
export const qubitApi = process.env.VUE_APP_QUBIT_API

export function isNewRoomDisplayActive() {
  // Overwrite in local flag SET -> ConfigDynamic.setKey('rd.new.activated', true)
  return true
}

export function isBookingUpsellingPageFF() {
  return global.ConfigDynamic.isEnabled(global.configDynamicKey.BOOKING_UPSELLING_PAGE)
}

export function isRoomDisplayMultiRoomVersionActive() {
  const value = global.ConfigDynamic.valueOf({
    key: 'booking.rd.multiroom.active',
    defaultValue: ''
  })
  return ['V1', 'V2'].includes(value)
}

export function isRoundedPriceEnabled() {
  return global.ConfigDynamic.isEnabled(global.configDynamicKey.ROUNDED_PRICE)
}

export const CrowdTypes = {
  DISCOUNT: 'CR_DISC',
  TRIPLE_POINTS: 'CR_POINTS'
}

export function isRtl() {
  return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl'
}

export function isTurkish() {
  const lang = document.documentElement.getAttribute('lang') || ''
  return lang.toLowerCase() === 'tr-tr'
}

export function isHebrew() {
  const lang = document.documentElement.getAttribute('lang') || ''
  return lang.toLowerCase() === 'he-il'
}

export function localePathException() {
  const locales = [
    'nl-nl',
    'el-gr',
    'it-it',
    'da-dk',
    'lt-lt',
    'ru-ru',
    'th-th',
    'uk-ua',
    'vi-vn',
    'zh-tw',
    'zh-cn',
    'id-id'
  ]

  const path = window.location.pathname.toLowerCase()
  return locales.some(locale => path.includes(locale))
}
